export default [
  {
    methods: ["GET"],
    uri: "api/v1/learning/order/confirm/{key}",
    name: "learning.order.confirm",
  },
];
